import {useEffect, useContext} from 'react';

import { 
	toast, 
	ToastContainer,
	// Slide, 
	// Zoom, 
	//Flip, 
	Bounce,
} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UIContext } from '../../contexts/UIContext';


const Toasts = () => {
	
	const { toastStore } = useContext (UIContext);

	useEffect(() => {
		
		//초기 데이터는 노티하지 않음
        if(toastStore.contents === "init") return;
		

		switch (toastStore.type) {
			case 'info': toast.info (toastStore.contents, {transition: Bounce}); break;
			case 'success': toast.success (toastStore.contents, {transition: Bounce}); break;
			case 'warning': toast.warn (toastStore.contents, {transition: Bounce}); break;
			case 'error': toast.error (toastStore.contents, {transition: Bounce}); break;
			case 'default': toast (toastStore.contents, {transition: Bounce}); break;
		}
			
  }, [toastStore]);


	//if(toastStore.contents === "init") return;

	return (
		<ToastContainer			
			position="top-center" // 알람 위치 지정
			autoClose={3000} // 자동 off 시간
			hideProgressBar={false} // 진행시간바 숨김
			closeOnClick // 클릭으로 알람 닫기
			rtl={false} // 알림 좌우 반전
			pauseOnFocusLoss // 화면을 벗어나면 알람 정지
			draggable // 드래그 가능
			pauseOnHover // 마우스를 올리면 알람 정지
			theme="light"
			// limit={1} // 알람 개수 제한
		/>
	);
}

export default Toasts;